import { track } from 'utils/tracking';
import { ITrackingProductPageBaseParameters } from '../shared/baseParameters';
import { fillVerticalCode } from '../shared/fillVerticalCode';

export const trackApplyLeadFormInteract = (
  parameters: {
    componentType: string;
    componentTitle: string;
    fieldValue: string;
    action?: string;
    status?: 'success' | 'failure' | '';
  } & Pick<ITrackingProductPageBaseParameters, 'productUid'>,
): void => {
  const {
    componentType,
    componentTitle,
    fieldValue,
    action,
    status = '',
  } = parameters;

  return track({
    event: 'form_interact',
    lead_form_name: 'apply-lead-detail-form',
    form_type: 'apply form',
    action: action ?? 'fill',
    component_type: componentType,
    component_title: componentTitle,
    ...fillVerticalCode(parameters),
    form_field_value: fieldValue ?? null,
    step_number: '1',
    step_name: 'lead-submission',
    status,
  });
};
